
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-hero/free-facility/[companyname]",
      function () {
        return require("private-next-pages/national-hero/free-facility/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-hero/free-facility/[companyname]"])
      });
    }
  